<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          1:1문의 상세
        </div>
        <div>
          <board-write-component :board-type="`qnaUpdate`" :boardKey="boardKey"></board-write-component>
        </div>
        <div class="pa15 text-center btn_wrap">
          <el-button class="reg_btn_out" @click="save">저장</el-button>
          <el-button class="reg_btn_out" @click="deleteBoard">삭제</el-button>
          <el-button class="com_btn" @click="backEvent()">목록</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import BoardWriteComponent from "@/components/board/BoardWriteComponent";

export default {
  name: "QnaDetail",
  mixins: [],
  components: {
    BoardWriteComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
      boardKey: this.$route.params.idx,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    save() {
      EventBus.$emit('writeBoard');
    },
    deleteBoard() {
      EventBus.$emit('runDeleteConfirm');
    },
    backEvent() {
      this.$router.back()
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>